import { FC, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import SearchParams from '@/_constants/SearchParams.ts';
import Routes from '@/router/Routes.ts';
import { queryClient } from '@/main.tsx';
import LoaderWrapper from '@/components/ui/LoaderWrapper/LoaderWrapper.tsx';

const AfterPaymentLandingPage: FC = () => {
  const [searchParams] = useSearchParams();
  const redirectUrlParam = searchParams.get(SearchParams.REDIRECT_URL);
  const navigate = useNavigate();

  useEffect(() => {
    const timeout = setTimeout(async () => {
      await queryClient.invalidateQueries({ queryKey: ['user'] });
      await queryClient.invalidateQueries({ queryKey: ['subscriptions'] });
      await queryClient.invalidateQueries({ queryKey: ['user_features'] });

      if (redirectUrlParam) {
        window.location.href = redirectUrlParam;
        return;
      }

      navigate(Routes.DASHBOARD);
    }, 1000);

    return () => {
      clearTimeout(timeout);
    };
  }, [redirectUrlParam, navigate]);

  return <LoaderWrapper isLoading={true} className="h-[100dvh]" />;
};

export default AfterPaymentLandingPage;
